import { mix } from "@chorda/core";
export const Image = (props) => {
    return mix({
        tag: 'figure',
        css: 'image',
        templates: {
            image: {
                tag: 'img',
                reactions: {
                    url: (v) => ({ dom: { src: v } })
                }
            }
        }
    }, props && {
        css: props.css,
        components: {
            image: {
                dom: {
                    src: props.url,
                    loading: props.lazy && "lazy"
                },
                classes: {
                    'is-rounded': props.rounded
                }
            }
        },
        injections: {
            url: props.url$
        }
    });
};
